<template>
  <div>
    <div id="chart-container" class="by-sales-wizard">
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-sales-wizard-e-chart" class="chart-row">
        <profile-chart-header
          :title="'Decision Styles | ' + titleSuffix"
          :display="this.$parent.getDisplayView() && getDisplayView()"
          :content-list="contentList"
          :content-name="'Wizard'"
          :display-download-comments="false"
          :display-show-respondents="false"
          :display-show-tooltip="false"
        />

        <sales-wizard-chart ref="eChart"
          :e-chart-mini-id="'sales-wizard-chart-mini'"
          :e-chart-id="'sales-wizard-chart'"
          :input-report-type-name="'Chart - Sales Wizard'"
          :modal-id="'sales-wizard-chart'"
          :is-saved-card="$parent.clientChart.clientChartId != 0"
          :input-client-chart="this.$parent.clientChart"
          :client-id="clientId"
          :inputDownloadFileName="'Decision Styles - ' + fileDownloadNameSuffix"
          :input-sales-wizard-data="salesWizardData"
          @save-table="saveSalesWizardDataTable"
          @save-criteria="buildClientChart"
        />
      </div>

      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="salesWizardTable.tableContainerId" :class="isInsiderUser ? 'chart-data hide-table-data' : 'chart-data'">
        <div v-show="isInsiderUser" class="overlay">
          <img class="overlay-inner" v-show="isInsiderUser" src="../../../assets/img/overlap.png" style="width: 50%"/>
        </div>
        <chart-data-table
          ref="salesWizardDataTable"
          v-show="this.$parent.getDisplayView() && getDisplayView()"
          :chart-data="this.salesWizardTable.data"
          :is-saved-card="$parent.clientChart.clientChartId != 0"
          :display-direction="'vertical'"
          :data-container-id="salesWizardTable.tableContainerId"
          :container-id="'sales_wizard_chart'"
          :column-defs="this.chart.columnDefs"
          :table-class="'table display row-border table-hover'"
          :table-width="'auto'"
          :table-title="this.salesWizardTable.title"
          :report-page-type-name="'Table - Sales Wizard'"
          :insight-modal-id="'sales-wizard-table'"
          :content-list="this.contentList"
          :inputDownloadFileName="'Decision Styles - ' + fileDownloadNameSuffix"
          :effort-list="needsEffortList"
          :use-alternate-title="true"
          :display-profile-strength-legend="$parent.displayProfileStrengthLegend"
          @display-initiatives="$parent.displayInitiativesForProfileTable"
          @go-to-explore="$parent.goToExploreForProfileTable"
        />
      </div>
    </div>

    <insights
      ref="insightsChart"
      :modal-name="'sales-wizard-chart'"
      :report-page-type-name="'Chart - Sales Wizard'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsTable"
      :modal-name="'sales-wizard-table'"
      :report-page-type-name="'Table - Sales Wizard'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>

<script>
import $ from "jquery";
import SalesWizardChart from "../../../views/echarts/SalesWizardChart.vue";
import ProfileChartHeader from "../../../components/echarts/ProfileChartHeader.vue";

import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";

export default {
  name: "BySalesWizard",
  mixins: [ChartCompanyMixins],
  components: { SalesWizardChart, ProfileChartHeader },
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    },
    contentList: {
      type: Array,
      default: () => []
    },
    verbatimsData: {
      type: Object,
      default: () => ({})
    },
    fileDownloadNameSuffix: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      displayType: "sales-wizard",
      needsEffortList: [],
      salesWizardTable: {
        id: "",
        data: {},
        title: '<div class="title"><h4 class="text-primary">Sales Wizard</h4></div>',
        tableContainerId: "sales_wizard_data_container",
      },
      isMobile: false,
      titleSuffix: "",
      clientId: 0,
      pageContentForReport: [],
      eChartCriteria: {
        displayNumberOfResponses: false,
        showTooltip: true,
      },
      salesWizardData: {
        title: "",
        rows: []
      }
    };
  },
  methods: {

    // Placeholder to persist data table. Mirrors ByNeed/ByMoat pattern.
    saveSalesWizardDataTable: async function() {
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        const vm = this;
        setTimeout(function() {    
          ReportService.saveReportTableFile(vm.$refs.salesWizardDataTable.getTableData(), "Table - Sales Wizard", vm.$parent.clientChart, vm.saveReportTableFileCallback, vm);
          ReportService.saveReportPage(vm.getReportTableContent("sales_wizard_chart"), "Table - Sales Wizard", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
        }, 1500);        
      }
    },
    processChartData: function() {
      try {
        this.chart = ChartService.getChartAttributes("Profile By Sales Wizard");
        let chartData = JSON.parse(JSON.stringify(this.chartData[0]));
        this.chart.columnDefs = TableService.getSalesWizardTableColumnAttributes();
        let otherData = chartData["otherData"];
        this.$parent.setChartResults(chartData.companyList);
        this.$parent.$data.criteriaResultsList = AdminService.removeByName(chartData.criteriaList, "Competitor");

        this.companyColorList = otherData["companyColorList"];
        TableService.setCompanyColorList(this.companyColorList);

        let titleSuffix = otherData["titleSuffix"];
        if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
          this.titleSuffix = titleSuffix;
        }
        
        let individualRespondents = this.getIndividualRespondents(otherData);
        // for AI Sales Wizard Recommendations
        this.setSalesWizardRecommendationData(individualRespondents,this.companyColorList,this.titleSuffix);

        let copyOfChartData = JSON.parse(JSON.stringify(chartData));
        this.salesWizardTable.data = JSON.parse(JSON.stringify(copyOfChartData));
        let chartDataMapList = otherData["chartDataMapList"];
        if (typeof chartDataMapList != "undefined" && chartDataMapList.length > 0) {
          this.salesWizardData.rows = JSON.parse(JSON.stringify(chartDataMapList));
          this.$refs.eChart.processChart(true, this.salesWizardData, this.eChartCriteria);
        }
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
      } catch (err) {
        ErrorService.processException("BySalesWizard.displayChartCallback", err, "chart", this);
      }

    },


    async saveAllReportPages(pages) {
      try {
        await ReportService.saveAllReportPages(pages);
      } catch (e) {
        ErrorService.onError(e);
      }
    },
    getIndividualRespondents(otherData) {
      if (typeof otherData == "undefined" || otherData == null) {
        return [];
      }
      // if (typeof otherData.respondents != "undefined" && otherData.respondents != null) {
      //   return JSON.parse(JSON.stringify(otherData.respondents));
      // }
      if (typeof otherData.individualRespondents != "undefined" && otherData.individualRespondents != null) {
        return JSON.parse(JSON.stringify(otherData.individualRespondents));
      }
      // if (typeof otherData.individualRespondentList != "undefined" && otherData.individualRespondentList != null) {
      //   return JSON.parse(JSON.stringify(otherData.individualRespondentList));
      // }
      return [];
    },
    setSalesWizardRecommendationData(individualRespondents, companyColorList, titleSuffix) {
      const recommendationData = {};
      recommendationData.individualRespondents = individualRespondents;
      recommendationData.companyColorList = companyColorList;
      recommendationData.titleSuffix = titleSuffix;
      //recommendationData.competitors = companyList["competitor"];
      this.$emit("set-sales-wizard-data", recommendationData);
    },
    displayIndividualRespondentsModal() {
      this.$modal.show("individual-respondents-modal");
    },
  },
  created() {
    // Initialize values familiar from other profile views
    this.clientId = this.$parent && this.$parent.clientObject ? this.$parent.clientObject.clientId : 0;
  },
  mounted() {},
  watch:{
    chartData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "sales-wizard") {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
